// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function authHeader(store: any) {
  const jwtString = store.getters.jwtToken
  if (jwtString == null) {
    return {}
  }
  return { Authorization: "Bearer " + jwtString };
}
